import React from "react";
import {connect} from "react-redux";
import ProgressIndicator from "../../../progress-indicator/progress-indicator";
import Heading from "../../../heading/heading";
import {RECEIVED_STUDENT_ASSIGNMENT_RESULTS, ElasticSearchTypes, ElasticSearchColumns} from "../../../../actions/types";
import classnames from "classnames";
import {browserHistory} from "react-router";
import LoginUtils from "../../../common/login-utils";
import "./student-assignment.css";
import "../../../reports/view/view-report.css";
import MaterialIcon from "react-google-material-icons";
import {Alert} from "react-bootstrap";
import apiClient from "../../../../actions/api-client";

class ReportCard extends React.Component {
    constructor(props) {
        super(props);
        this.loadStudentDetails = this.loadStudentDetails.bind(this);

        this.state = {screenWidth: window.innerWidth,loadingNextPage: 0, categoryData:[], selectedType:'cumulative'};
        this.filterComponentCssClassName = 'filterBlock filterBlockBox NiceScroll';
        this.tableCssClassName = 'listViewBlock ';

        this.state.subjects = (this.props.location && this.props.location.state) ? this.props.location.state.subjects : []
    }

    componentDidMount() {
        let context = this;
        LoginUtils.isAuthenticated(this.props, browserHistory, '/student/assignments', '/');
        this.loadStudentDetails(this.props.auth.user.userName).then((result) => {
            
            context.setState({
                cumulative: result.cumulative,
                practiceAssignment: result.practiceAssignment,
                assignment: result.assignment
            });
        }, (error) => {
            console.error(error);
        })
    }

    render() {
        const {screenWidth} = this.state;
        let context = this;
        let categoryData = [];
        if(this.state.selectedType === 'cumulative'){
            categoryData = context.state.cumulative || [];
        }else if(this.state.selectedType === 'practice'){
            categoryData = context.state.practiceAssignment || [];
        }else if(this.state.selectedType === 'assignment'){
            categoryData = context.state.assignment || [];
        }
        let subjectScore = 0;
        let questions = 0;
        let correctAns = 0;
        categoryData.forEach((cat) => {
            questions += cat.totalQuestions;
            correctAns += cat.answeredCorrectly;
        });

        if (correctAns === 0 && questions === 0) {
            subjectScore = 0;
        } else {
            subjectScore = (correctAns / questions) * 100;
            subjectScore = subjectScore.toFixed(0);
        }

        categoryData = categoryData.sort((a,b) => {
            return a.category.localeCompare(b.category);
        });
        let rows = [];
        categoryData.forEach((category) => {
            let average = 0;
            let color = 'black';
            average = category.average;
            if (average.toFixed(0) < 65)
            {
                color = 'red';
            }

            rows.push(<tr key={'category-parent-' + category.category} id={category.category}>
                <td id="allRows" data-parent-id={category.category} data-is-expanded={false} style={{width:'40%'}}>
                    <a href="javascript:void 0" onClick={function (evt) {
                        var parent = evt.target.parentElement.parentElement;
                        var rows = document.querySelectorAll('tr[id*=\"parent-' + parent.dataset.parentId + '\"]');
                        if (parent.dataset.isExpanded === 'false') {
                            parent.dataset.isExpanded = 'true';
                            parent.firstElementChild.lastElementChild.textContent = 'remove_circle_outline';
                            for (let i = 0; i < rows.length; i++) {
                                rows[i].style.display = '';
                            }
                        } else {
                            parent.firstElementChild.lastElementChild.textContent = 'add_circle_outline';
                            parent.dataset.isExpanded = 'false';
                            for (let i = 0; i < rows.length; i++) {
                                rows[i].style.display = 'none';
                            }
                        }
                    }.bind(this)} data-parent-id={category.category}><strong>{category.category}</strong><MaterialIcon icon="add_circle_outline" size={24}/></a>
                </td>
                <td style={{width:'15%', color:color}}>
                    {average ? average.toFixed(0):0}{'%'}
                </td>
                <td style={{width:'15%'}}>
                    {category.totalQuestions}
                </td>
                <td style={{width:'15%'}}>
                    {category.answeredCorrectly}
                </td>
                <td style={{width:'15%'}}>
                    {category.answeredIncorrectly}
                </td>
            </tr>);

            category.subCategories.forEach(subCat => {
                let average = 0;
                let color = 'black';
                average = subCat.average
                if (average.toFixed(0) < 65)
                {
                    color = 'red';
                }
                rows.push(<tr key={'category-child-' + subCat.category} id={'parent-' + category.category + subCat.category}
                              data-category-parent-id={category.category} style={{display:'none'}}>
                    <td className="indentSubCat">
                        {subCat.category}
                    </td>
                    <td style={{color:color}}>
                        {average.toFixed(0)}{'%'}
                    </td>
                    <td>
                        {subCat.totalQuestions}
                    </td>
                    <td>
                        {subCat.answeredCorrectly}
                    </td>
                    <td>
                        {subCat.answeredIncorrectly}
                    </td>
                </tr>);
            });
        });

        let studentStats = <table className="table" id="student-attempt-history">
            <thead>
            <tr>
                <th>
                </th>
                <th>
                    Average
                </th>
                <th>
                    Total Questions
                </th>
                <th>
                    Answered Correctly
                </th>
                <th>
                    Answered Incorrectly
                </th>
            </tr>
            </thead>
            <tbody>
            {rows}
            </tbody>
        </table>;

        let onChange = function (evt) {
            this.setState({
                selectedType: evt.target.value
            });

            let parents = [...document.querySelectorAll('td[id*=allRows]')];
            parents.forEach(parent=>{
                let rows = document.querySelectorAll('tr[id*=\"parent-' + parent.dataset.parentId + '\"]');
                if (parent.dataset.isExpanded === 'true') {
                    parent.firstElementChild.lastElementChild.textContent = 'add_circle_outline';
                    parent.dataset.isExpanded = 'false';
                    for (let i = 0; i < rows.length; i++) {
                        rows[i].style.display = 'none';
                    }
                }
            });
        }.bind(context);

        let table = <div id="user-activity-analysis" className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <p className="subjectScoreHeading" style={{marginTop:"-10px"}}>
                    {this.props.params.subject} : <span style={{color:subjectScore < 65 ? 'red':'green'}} className="subjectScoreHeadingSpan">{subjectScore===NaN ? 0:subjectScore}{'%'}</span>
                </p>
                <p style={{overflow: 'auto'}}>
                    {studentStats}
                </p>
            </div>
        </div>;

        return (
            <div id="ReportCard">
                <Heading
                    isQuery={false}
                    customURL={ElasticSearchTypes.StudentAssignment}
                    location = "studentAssignment"
                    actionName = {RECEIVED_STUDENT_ASSIGNMENT_RESULTS}
                    isSearch={false}
                    isShowButton={false}
                    screenNameForElasticSearch = {this.props.auth.user.userName}
                    allColumnsForElasticSearch = {ElasticSearchColumns.StudentAssignment}
                    breadcrumbsData={[
                        {
                            name: 'Reports', action: ()=> {
                            browserHistory.push('/student/reports');
                        }
                        },
                        {
                            name: 'Grade Tracker'
                        }
                    ]}
                />
                {this.state.showAlert &&
                <div className="row">
                    <div className="col-md-3 col-xs-3"/>
                    <div className="col-md-6 col-xs-3">
                        <Alert bsStyle={this.state.alertStyle}
                               onDismiss={this.handleAlertDismiss}>
                            {this.state.alertText}
                        </Alert>
                    </div>
                    <div className="col-md-3 col-xs-3"/>
                </div>
                }
                <div id="tableFiltersAndSideView">
                    <div className={classnames("container-fluid noPad listMainBoxWrapper")}>
                        <div className="radioElementBox col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <p className="reportTypeHeading">
                                Report Card Type
                            </p>
                            <div className="radioElement">
                                <div className="fieldBox"><input type="radio" value={"assignment"} onChange={onChange} className="css-checkbox css-label1 bc_info card_side" id="choice-0" name="report_type" /><label className="css-label " htmlFor="choice-0" >Teacher Assignments</label></div>
                                <div className="fieldBox"><input type="radio" value={"practice"} onChange={onChange} className="css-checkbox css-label1 bc_info card_side" id="choice-1" name="report_type" /><label className="css-label " htmlFor="choice-1" >Self-Study</label></div>
                                <div className="fieldBox"><input type="radio" value={"cumulative"} defaultChecked={true} onChange={onChange} className="css-checkbox css-label1 bc_info card_side" id="choice-2" name="report_type" /><label className="css-label " htmlFor="choice-2" >Cumulative</label></div>
                            </div>
                        </div>
                        <div id="ReportCardTable1" style={{background:'white'}} className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                            {table}
                        </div>
                    </div>
                </div>
                <ProgressIndicator show={this.state.loading}/>
                {this.state.showUserDetailsDialog && this.getUserDetailsDialog()}
            </div>
        );
    }

    loadStudentDetails(studentID){
        let context = this;
        context.showIndicator();
        return new Promise((resolve, reject) => {
            let context = this;

            let params = {
                studentID: studentID,
                subject: this.props.params.subject
            };
            let pathTemplate = '/assignment/analysis/student/{studentID}/subject/{subject}';
            let method = 'GET';
            // let additionalParams = { queryParams : { subjects: this.state.subjects.map(sub => sub.id) } };
            let additionalParams = {};
            let body = {};
            apiClient.invokeApi(params, pathTemplate, method, additionalParams, body, '4').then(function (result) {
                context.hideIndicator();
                resolve(result.data);
            }).catch(function (error) {
                context.setState({
                    showAlert: true,
                    alertStyle: 'danger',
                    alertText: 'Unable to load data, please contact administrator.'
                });
                setTimeout(()=> {
                    context.setState({
                        showAlert: false,
                        alertStyle: '',
                        alertText: ''
                    })
                }, 4000);
                reject(error);
            });
        });
    }

    showIndicator() {
        this.setState({
            loading: true
        });
    }

    hideIndicator() {
        this.setState({
            loading: false
        });
    }
}

function mapStateToProps(state) {
    return {
        ...state
    }
}

export default connect(mapStateToProps)(ReportCard);
